export default function InputBase() {
  return {
    MuiInputBase: {},
  };
}
